import {ComputerDesktopIcon, MoonIcon, SunIcon} from "@heroicons/react/16/solid";
import {useMemo} from "react";
import {useOtsColorSchemePreference} from "../theme/useOtsColorSchemePreference";
import type {OtsAppNavbarMenuItem} from "./OtsAppNavbar";

/** The account menu's light/dark choice, as a group of items starting with a rule. */
export const useOtsAppearanceMenuItems = (): OtsAppNavbarMenuItem[] => {
  const {choice, setChoice} = useOtsColorSchemePreference();
  return useMemo(() => [
    {id: "theme-system", label: "Match system", icon: <ComputerDesktopIcon/>, onClick: () => setChoice("system"), selected: choice === "system", separated: true},
    {id: "theme-light", label: "Light", icon: <SunIcon/>, onClick: () => setChoice("light"), selected: choice === "light"},
    {id: "theme-dark", label: "Dark", icon: <MoonIcon/>, onClick: () => setChoice("dark"), selected: choice === "dark"},
  ], [choice, setChoice]);
};
